import dxfReader from './dxf/index.js'
import dwgReader from './dwg/index.js'

const READERS = {
  dxf: dxfReader,
  dwg: dwgReader,
}

/** Devuelve el reader correcto según la extensión del archivo. */
export function getReader(url) {
  const extension = url.split('.').pop().toLowerCase()
  const reader = READERS[extension]
  if (!reader) {
    throw new Error(`Formato CAD no soportado: ${extension}`)
  }
  return reader
}

/** Atajo: detecta el formato y delega. */
export function load(url, options={}) {
  const reader = getReader(url)
  return reader.load(url, options)
}

export async function loadFromFile(file, options = {}) {
  const extension = file.name.split('.').pop().toLowerCase()
  const reader = READERS[extension]
  if (!reader) {
    throw new Error(`Formato CAD no soportado: ${extension}`)
  }
  const blobUrl = URL.createObjectURL(file)
  try {
    return await reader.load(blobUrl, options)
  } finally {
    URL.revokeObjectURL(blobUrl)
  }
}
